export default {
  name: "mDiamondItem",
  props: {
    item: null,
    index: null
  }
};